export default "__VITE_ASSET__D7hKpV15__"